/**
 * Printer's registration mark (target): a ring with a crosshair that runs past
 * it. The brand's signal glyph — used where something is "in register":
 * the active nav item, the hero's registered print, the process stations.
 * Decorative; the colour comes from `currentColor` (default --signal via .reg).
 *
 * @param {{ className?: string, size?: number }} props
 */
export default function RegMark({ className = 'reg', size = 18 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="6.5" />
      <path d="M12 1v22M1 12h22" />
    </svg>
  )
}
